import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    isPC: state => state.isPC,
    isMobile: state => state.isMobile,
    isLandscape: state => state.isLandscape
  },
  state: {
    isPC: true,
    isMobile: false,
    isLandscape: false
  },
  actions: {
    setPlatform ({ commit }, isPC) {
    },
    setMobile ({ commit }, isMobile) {
    },
    setOrientation ({ commit }, isLandscape) {
    }
  },
  mutations: {
    SET_MOBILE (state, isMobile) {
      // state.isMobile = isMobile
    },
    SET_PLATFORM (state, isPC) {
      // state.isPC = isPC
      // state.isMobile = !isPC
    },
    SET_ORIENTATION (state, isLandscape) {
      // state.isLandscape = isLandscape
    }
  }
})
